import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SelectSurveyModalComponent } from '../select-survey-modal/select-survey-modal.component';
import { Router } from '@angular/router';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import {ConstantsService} from "../../../../services/constants/constants.service";

@Component({
  selector: 'app-select-survey',
  templateUrl: './select-survey.component.pug',
  styleUrls: ['./select-survey.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SelectSurveyComponent implements OnInit {

  selectSurveyModal: BsModalRef;
  selectedSurvey:any[] = [];
  @Input() disabled: any= false;
  @Input() selectedSurveyTab: string = '';

  constructor(
    private router: Router,
    private modalService: BsModalService,
    private permission: PermissionsService
  ) {
    this.selectSurveyModal = new BsModalRef();
  }

  ngOnInit(): void {
  }

  openSelectSurvey(initialise:any[]=[]): void {
    /*
    const initialState = {
      'initialise': initialise
    }
    */
    this.selectSurveyModal = this.modalService.show(
      SelectSurveyModalComponent,
      Object.assign({}, { class: 'modal-dialog-centered select-survey-modal'}),
    );
    this.selectSurveyModal.content.closeBtnName = 'Close';

    this.selectSurveyModal.content.selectClick.subscribe(res => {
      this.router.navigateByUrl('surveys/start-point', { state: { surveyType: res.data } });
    });
  }

  createTooltip() {
    switch (this.selectedSurveyTab) {
      case 'reference':
        return ConstantsService.REFERENCE_NONE_TOOLTIP;
      case 'pulse':
        return ConstantsService.PULSE_CHECK_NONE_TOOLTIP;
      case 'exit':
        return ConstantsService.EXIT_CHECK_NONE_TOOLTIP;
      default:
        return ''
    }
  }
}
